import React from 'react'
import DevelopmentsGrid from '../1'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  tag: string
}
type CombinedProps = ExternalProps & RealEstateDataPageComponentData

const GridDevelopment6 = (props: CombinedProps) => {
  return <DevelopmentsGrid {...props} />
}

export default GridDevelopment6
